module.exports = __webpack_public_path__ + "static/media/bet-yellow-2.693a8fe6.png";